module.exports = __webpack_public_path__ + "dbd7260297db10b0c6a15f949824fdba.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/Assets/generalserveguide.png
// module id = 1320
// module chunks = 0